import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Segment, Container } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";

const CountAllSuccessPayrolls = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    loadCountAllSuccessPayrolls,
    countAllSuccessPayrolls,
  } = rootStore.dashboardStore;

  return (
    <Segment className="totalDocumentos" clearing>
      <div>
        <div className="graphictitle">
          <p>Total nóminas electrónicas</p>
        </div>
        <div className="graphicontwithoutpadd">
          {!loadCountAllSuccessPayrolls ? (
            <LoadingComponent content="Cargando" />
          ) : (
            <Container textAlign="center">
              <p className="greenlabelstyle size250">{countAllSuccessPayrolls}</p>
            </Container>
          )}
        </div>
      </div>
    </Segment>
  );
};

export default observer(CountAllSuccessPayrolls);
